if (!customElements.get('foam-feature-media')) {
  customElements.define(
    'foam-feature-media',
    class FoamFeatureMedia extends HTMLElement {
      connectedCallback() {
        if (!this.querySelector('.foam-feature__label')) return;
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

        this.setAttribute('data-animate', '');

        // Fade in once 40% of the image is visible; fade out only after it fully leaves the viewport.
        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.intersectionRatio >= 0.4) {
                this.classList.add('is-visible');
              } else if (!entry.isIntersecting) {
                this.classList.remove('is-visible');
              }
            });
          },
          { threshold: [0, 0.4] }
        );
        this.observer.observe(this);

        this.onBlockSelect = (event) => {
          if (this.contains(event.target)) this.classList.add('is-visible');
        };
        document.addEventListener('shopify:block:select', this.onBlockSelect);
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        if (this.onBlockSelect) document.removeEventListener('shopify:block:select', this.onBlockSelect);
      }
    }
  );
}
